import { Component } from '@angular/core';
import { Bootstrap4FrameworkComponent } from '@ajsf/bootstrap4';

/* Custom framework component for angular6-json-schema-form */
@Component({
    selector: 'app-framework',
    templateUrl: './framework.component.html',
    styleUrls: ['./framework.component.css'],
})
export class GNCFrameworkComponent extends Bootstrap4FrameworkComponent {}
